export default __webpack_public_path__ + "static/media/sausage.6b834172.svg";